<template>
  <div class="spinner">
    <img src="@/assets/loading.gif">
  </div>
</template>

<script>
export default {
  name: 'LoadingIndicator'
}
</script>

<style scoped>
.spinner {
  border-width: 1px;
  border-color: light-gray;
}

.spinner > img {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/LoadingIndicator.vue